export function productManagementView(pathname: string) {
  if (pathname.startsWith('/product-management/products/')) return 'product-detail';
  switch (pathname) {
    case '/product-management/collections': return 'product-collections';
    case '/product-management/search': return 'product-search';
    case '/product-management/synchronization': return 'product-sync';
    default: return null;
  }
}
